import { useEffect, useState } from 'react';
import { Drawer, Input, Button, Flex, Box } from '@mantine/core';
import styled from 'styled-components';

export default function CustomTableDrawer({
  isOpen,
  onClose,
  onSubmit,
  isLoading,
  initialValue,
  disabled,
  isUpdate = false
}) {
  const [tableName, setTableName] = useState(initialValue || '');

  useEffect(() => {
    setTableName(initialValue || '');
  }, [initialValue]);

  const handleSubmit = e => {
    e.preventDefault();
    if (!tableName) return;

    onSubmit(tableName, () => {
      setTableName('');
    });
  };

  const onChange = e => setTableName(e.target.value);

  return (
    <Drawer
      id="data-extraction-custom-table-drawer"
      title={isUpdate ? 'Update Custom Table Name' : 'Add Custom Table'}
      opened={isOpen}
      onClose={onClose}
      position="right"
      size="md"
      lockScroll={false}
      withinPortal={false}
      overlayProps={{
        display: 'none'
      }}
    >
      <form id="data-extraction-custom-table-form" onSubmit={handleSubmit}>
        <Box id="data-extraction-custom-table-body">
          <Input.Wrapper id="data-extraction-custom-table-name-wrapper" label="Custom Table Name">
            <Input
              id="data-extraction-custom-table-name-input"
              value={tableName}
              onChange={onChange}
              autoFocus
            />
          </Input.Wrapper>
          <Flex id="data-extraction-custom-table-footer" justify="flex-end" mt="48px">
            <Button
              id="data-extraction-custom-table-save"
              type="submit"
              size="xs"
              disabled={disabled}
              isLoading={isLoading}
            >
              Save
            </Button>
          </Flex>
        </Box>
      </form>
    </Drawer>
  );
}

const Form = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 12px;
`;

const Footer = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  margin-top: 48px;
`;
